"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _utils = require("../../utils");
var _index = _interopRequireDefault(require("../../renderings/VerticalCard/index"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * A horizontal timeline
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} A React Element
 */
function HorizontalTimeline(props) {
  if (!props.rendering.fields) return null;
  var cardProps = {
    rendering: {
      fields: ''
    },
    params: props.params
  };
  var extractedFields = (0, _utils.extractFieldsFn)(props);
  var newcardlist = extractedFields.DisplayCentered.value ? extractedFields.CardList.slice(0, 3) : extractedFields.CardList;
  return /*#__PURE__*/_react.default.createElement("div", {
    id: (0, _utils.getComponentContentId)(props.rendering.dataSource),
    className: 'app-container'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row card-list ".concat(extractedFields.DisplayCentered.value ? 'mm-horizontal-timeline' : '')
  }, newcardlist.map(comp => {
    cardProps = {
      rendering: {
        fields: comp.fields
      },
      params: props.params
    };
    cardProps.params.ImgHeight = extractedFields.VerticalCardImgHeight.value;
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      xs: 12,
      md: "".concat(extractedFields.DisplayCentered.value ? '4' : (0, _utils.columnWidth)(extractedFields.CardList.length, 3)),
      className: "align-self-stretch",
      key: comp.id
    }, /*#__PURE__*/_react.default.createElement(_index.default, cardProps));
  })));
}
var _default = exports.default = HorizontalTimeline;